<div class="split-form">
  <div class="image-side order-lg-2 order-1 order-md-2">
    <h1 class="typing-text font-weight-bolder">Welcome to Lovely Fashion</h1>
    <h3 class="typing-text font-weight-bolder">
      <span>Exclusive {{ currentText }}</span>
      <span class="cursor">|</span>
    </h3>
    <h6 class="font-weight-lighter">Register your details to continue shopping</h6>
  </div>
  <div class="form-side order-lg-1 order-md-2 order-2">
    <div class="form">
      <h2 class="text-center font-weight-bolder">Sign Up</h2>
      <form [formGroup]="registerForm" (submit)="onSubmit()">
        <input type="text" placeholder="Name" formControlName="name">
        <span class="text-danger" *ngIf="registerErrors.name">{{ registerErrors.name }}</span>
        <input type="text" placeholder="Phone Number" formControlName="username" maxlength="10" (keypress)="allowOnlyNumbers($event)">
        <span class="text-danger" *ngIf="registerErrors.phoneNumber">{{ registerErrors.phoneNumber }}</span>
        <input type="email" placeholder="Email" formControlName="email">
        <span class="text-danger" *ngIf="registerErrors.email">{{ registerErrors.email }}</span>
        <div class="password-container">
          <input
            [type]="showPassword ? 'text' : 'password'"
            placeholder="Password"
            formControlName="password"
            maxlength="10"
            minlength="10"
          >
          <i class="bi" [ngClass]="showPassword ? 'bi-eye' : 'bi-eye-slash'"
             (click)="togglePasswordVisibility()"></i>
        </div>

        <span class="text-danger" *ngIf="registerErrors.password">{{ registerErrors.password }}</span>
        <button type="submit">Sign Up</button>

        <p class="mt-3 mb-0 text-bold text-center">Already register? <a [routerLink]="['/login']"
                                                                        class="text-decoration-none">Login</a></p>
      </form>
    </div>
  </div>
</div>
